import React, { useEffect } from 'react';
import Button from '../../components/button/Button';
import { useNavigate } from 'react-router-dom';
import PageSection from '../../components/pageSection/PageSection';
import Carousel from '../../components/carousel/Carousel';
import Image from '../../components/Image/Image';

const images = [
  {
    src: 'images/heat_pump.webp',
    altText: 'Heat Pump',
  },
  {
    src: 'images/heat_pump_2.webp',
    altText: 'Heat Pump',
    objectPosition: '0 -570px',
  },
];

export default function HeatPumps() {
  const navigate = useNavigate();

  useEffect(() => {
    window.scroll(0, 0);
  }, []);

  return (
    <>
      <div className="ui-page">
        <h1 className="ui-header-text">
          Heat Pumps: Energy-Efficient Heating & Cooling for Your Home
        </h1>
        <p className="ui-content-text">
          Looking for a reliable, cost-effective way to heat and cool your home?
          A heat pump could be the perfect solution! Heat pumps provide
          year-round comfort while reducing energy costs and environmental
          impact.
        </p>
        <br />
        <Carousel duration={5000}>
          {images?.map((image, index) => (
            <Image
              key={index}
              src={image.src}
              altText={image.altText}
              objectPosition={image?.objectPosition}
            />
          ))}
        </Carousel>
        <br />
        <Button
          block
          type="primary"
          size="large"
          letterSpacing="2px"
          onClick={() => navigate('/contact-us')}
        >
          CONTACT US
        </Button>
        <h2 className="ui-secondary-header-text">What is a Heat Pump?</h2>
        <p className="ui-content-text">
          A heat pump is a versatile HVAC system that transfers heat instead of
          generating it. In winter, it extracts heat from the outdoor air or
          ground and moves it indoors. In summer, it reverses the process,
          cooling your home by removing heat.
        </p>
        <h2 className="ui-secondary-header-text">Why Choose a Heat Pump?</h2>
        <ul>
          <li className="ui-content-text" style={{ listStyleType: 'none' }}>
            <b>✅ Energy Efficiency</b> – Uses significantly less energy than
            traditional heating and cooling systems.
          </li>
          <br />
          <li className="ui-content-text" style={{ listStyleType: 'none' }}>
            <b>✅ Cost Savings</b> – Lower utility bills and potential rebates
            or tax incentives.
          </li>
          <br />
          <li className="ui-content-text" style={{ listStyleType: 'none' }}>
            <b>✅ Eco-Friendly</b> – Reduces carbon footprint by using
            electricity instead of fossil fuels
          </li>
          <br />
          <li className="ui-content-text" style={{ listStyleType: 'none' }}>
            <b>✅ Year-Round Comfort</b> – Provides both heating and cooling
            with one system.
          </li>
          <br />
          <li className="ui-content-text" style={{ listStyleType: 'none' }}>
            <b>✅ Quiet Operation</b> – Runs more quietly compared to
            traditional HVAC systems.
          </li>
        </ul>
        <h2 className="ui-secondary-header-text">Types of Heat Pumps</h2>
        <ul>
          <li className="ui-content-text">
            <b>Air-Source Heat Pumps</b> – Transfer heat between indoor and
            outdoor air.
          </li>
          <br />
          <li className="ui-content-text">
            <b>Ground-Source (Geothermal) Heat Pumps</b> – Utilize the stable
            underground temperature for heating and cooling.
          </li>
          <br />
          <li className="ui-content-text">
            <b>Ductless Mini-Split Heat Pumps</b> – Ideal for homes without
            ductwork, offering zone-specific temperature control.
          </li>
        </ul>
        <h2 className="ui-secondary-header-text">
          Is a Heat Pump Right for You?
        </h2>
        <p className="ui-content-text">
          A heat pump is an excellent choice for homes in moderate climates but
          can also work efficiently in colder regions with advanced models. If
          you’re looking for an energy-efficient, all-in-one solution, a heat
          pump may be the best investment for your comfort and savings.
        </p>
        <h2 className="ui-secondary-header-text">
          Schedule a Free Consultation Today!
        </h2>
        <p className="ui-content-text">
          Our expert HVAC technicians are here to help you find the perfect heat
          pump for your home. Contact us today to learn more and get a free
          quote!
        </p>
        <br />
      </div>
      <PageSection
        title="Reach Out to Schedule an Appointment or Servicing"
        content="We will get back to you right away to fit you into the
                                schedule and get your needs met!"
        action={{
          title: 'CONTACT US',
          onClick: () => navigate('/contact-us'),
        }}
      />
    </>
  );
}
